<template>
  <div class="register-wrap">
    <form key="register" action="api/register" method="post" id="formlog">
      <oButton v-show="disable && value.dynamics == 'BC' && migrationStatus" class="migrate o-outline-light" buttonText="Migrate to OAuth" icon="fa fa-check-circle"/>
      <oButton v-show="disable && value.dynamics == 'BC' && isMigrated" @click="migrate" class="migrate" buttonText="Migrate to OAuth"/>
      <float-label label="Dynamics" form="formlog">
        <select ref="dynamics" v-model="customer.dynamics" name="Dynamics" @change="hdlDynamics" :disabled="disableDynamics()">
          <option v-for="partner in togglePartner" :key="partner.id" :value="partner.value">
            {{ partner.text }}
          </option>
        </select>
      </float-label>
      <float-label>
        <input v-model="customer.customerName" name="CustomerName" type="text" placeholder="Customer Name" :disabled="disable" :maxlength="24">
        <span class="textInfo" :class="{'texterror': (customer.customerName.length >= 24)} ">{{customer.customerName.length}}/24</span>
        <oButton v-show="exflowUrl" class="btn-clipboard" @click="hdlClipBoard(customer.customerName)" icon="fa fa-clipboard" />
      </float-label>
      <float-label v-show="exflowUrl != ''">
        <input v-model="exflowUrl" name="ExflowUrl" type="text" placeholder="Exflow Url" :disabled="disable">
        <oButton class="btn-clipboard" @click="hdlClipBoard(exflowUrl)" icon="fa fa-clipboard" />
      </float-label>
      <CheckBox  v-show="!isvNext && this.value.deployType != null" desc="Production environment:" :value="deployTypeCheck" :disable="disable" @change="hdlProdEnvCheckBox" />
      <float-label  v-show="toggleField">
        <input v-model="customer.company" name="Company" type="text" placeholder="Default Nav Company">
      </float-label>
      <float-label>
        <input v-model="customer.url" name="Url" type="url" placeholder="Service Url">
      </float-label>
      <CheckBox  v-show="isBcOnPrem" desc="HybridConnection:" :value="value.hybridConnection" :disable="disable" @change="hdlCheckBox" />
      <float-label v-show="checkEdit">
        <input v-model="customer.dynamicsSerialNumber" name="Dynamics Serial Number" type="text" placeholder="Tenant ID / Dynamics Serial Number (Required for AAD Auth)" >
        <oButton v-show="exflowUrl" class="btn-clipboard" @click="hdlClipBoard(customer.dynamicsSerialNumber)" icon="fa fa-clipboard" />
      </float-label>
      <float-label  v-show="isBcOnPrem">
        <input v-model="customer.username" name="Username" type="text" placeholder="Username">
      </float-label>
      <float-label v-show="isBcOnPrem">
        <input v-model="customer.password" name="Password" type="password" placeholder="Web Access Key">
      </float-label>
      <float-label label="Location" form="formlog">
        <select v-model="customer.location" name="Location" :disabled="disable">
          <option value="" selected disabled hidden>Location</option>
          <option v-for="location in locations" :key="location.id" :value="location.value">
            {{ location.text }}
          </option>
        </select>
      </float-label>
      <float-label v-show="isvNext">
        <input v-model="customer.security_Admins" name="Admin" type="text" placeholder="Admin">
      </float-label>
      <float-label v-show="isvNext">
        <input v-model="customer.appControlMergeFile" @paste="hdlPaste" name="SiteConfiguration" type="text" placeholder="Site Configuration">
      </float-label>
      <float-label v-show="adminConsent != ''">
        <input v-model="adminConsent" name="Admin Consent" type="text" placeholder="Admin Consent" :disabled="disable">
        <oButton class="btn-clipboard" @click="hdlClipBoard(adminConsent)" icon="fa fa-clipboard" />
      </float-label>
      <float-label label="Authentication" ref="auth">
        <select v-model="customer.authentication" name="Authentication" :disabled="localDisable">
          <option value="" selected disabled hidden>Authentication</option>
          <option v-for="option in authOptions" :key="option.id" :value="option.value">
            {{ option.text }}
          </option>
        </select>
      </float-label>
      <float-label v-show="formsTestSitePassword != ''">
        <input v-model="formsTestSitePassword" name="SitePassword" type="text" placeholder="Site Password" :disabled="disable">
        <oButton class="btn-clipboard" @click="hdlClipBoard(formsTestSitePassword)" icon="fa fa-clipboard" />
      </float-label>
      <float-label v-show="outboundIpAddresses != ''">
        <input v-model="outboundIpAddresses" name="OutboundIpAddresses" type="text" placeholder="OutboundIpAddresses" :disabled="disable">
        <oButton class="btn-clipboard" @click="hdlClipBoard(outboundIpAddresses)" icon="fa fa-clipboard" />
      </float-label>
      <float-label>
        <textarea v-model="customer.info" name="Info" placeholder="Other info"></textarea>
      </float-label>
      <div class="btn-wrapper">
        <oButton v-show="disable" @click="hdlMore" class="o-outline-light more" buttonText="More" />
        <oButton @click.prevent="register" class="btnSubmit" buttonText="Submit" />
      </div>
      <transition name="fade" >
        <div class="more-window-wrap" v-show="showMore">
          <div class="more-btn-wrapper">
             
            <oButton class="close-btn-more" icon="fas fa-window-close" @click="hdlMoreClose"/>

            <oButton @click="hdlOpenDelete" class="btnDelete outline" buttonText="Delete" />
            <oButton @click="hdlRestart" :disabled="exceptionDisable" class="o-outline-light" buttonText="Restart"/>
            <oButton @click="hdlExceptions" :disabled="exceptionDisable" class="o-outline-light" buttonText="Exceptions"/>
            <oButton v-show="value.vNextMigration == 'ActionRequired'" @click="hdlActionRequired" :disabled="exceptionDisable" class="o-outline-light-action" buttonText="Action required"/>
            <oButton v-show="value.vNextMigration == 'Prepared'" @click="hdlPostpone" :disabled=disableBtnDeployment class="o-outline-light" buttonText="Postpone Migration" />
            <oButton v-show="value.vNextMigration == 'Postponed'" :disabled="true" class="postpone o-outline-light" buttonText="Postpone Migration" icon="fa fa-check-circle"/>
            <oButton v-show="value.vNextMigration == 'Prepared' || value.vNextMigration == 'Postponed'" @click="hdlOpenMigrate" :disabled="exceptionDisable" class="o-outline-light" buttonText="Migrate"/>
          </div>
        </div>
        </transition>
      </form>

      <transition name="fade" >
        <div v-show="showDelete" class="delete-window">
          <div class="delete-window-wrap">
            <p>Are you sure you want to delete this deployment?</p>
            <div class="del-btn-wrapper">
                <oButton @click="hdlCancel" :disabled=disableBtnDeployment class="o-outline-light" buttonText="Cancel" />
                <oButton @click="hdlDelete" :disabled=disableBtnDeployment class="btnDelete" buttonText="Delete" />
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade" >
        <div v-show="showActionRequired" class="action-window">
          <div class="action-window-wrap">
            <div>
              <p>Please select environment:</p>
              <span>Set to <b>"true"</b> if this is a production site.</span>
            </div>
            <CheckBox desc="Production environment:" :value="toggleEnv" :disable=disableBtnDeployment @change="hdlEnvCheckBox" />
            <div class="action-btn-wrapper">
                <oButton @click="hdlCancelActionRequired" :disabled=disableBtnDeployment class="o-outline-light" buttonText="Cancel" />
                <oButton v-show="disable" @click="hdlEnvironment" :disabled="disableBtnDeployment" class="btnSubmit" buttonText="Submit"/>
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade" >
        <div v-show="showMigrate" class="migrate-window">
          <div class="migrate-window-wrap">
            <p>Are you sure you want to Migrate?</p>
            <div class="migrate-btn-wrapper">
                <oButton @click="hdlCancelMigrate" :disabled=disableBtnDeployment class="o-outline-light" buttonText="Cancel" />
                <oButton v-show="disable" @click="migratevNext" :disabled="disableBtnDeployment" class="btnSubmit" buttonText="Migrate"/>
            </div>
          </div>
        </div>
      </transition>
  </div>
</template>

<script>
import oButton from './oButton'
import CheckBox from './CheckBox'
import FloatLabel from './FloatLabel'

export default {
  name: 'BxRegisterForm',
  components: {
    oButton,
    CheckBox,
    FloatLabel
  },
  props: ['userValue', 'token', 'value', 'disable', 'dynamics'],
  data() {
    return {
      customer: {
        dynamics: this.checkPartner() || this.value.dynamics || '',
        customerName: this.value.customerName || '',
        company: this.value.company || '',
        deployType: this.value.deployType || '',
        url: this.value.url || '',
        dynamicsSerialNumber: this.value.dynamicsSerialNumber || '',
        username: this.value.username || '',
        password: '',
        location: this.value.location || '',
        info: this.value.info || '',
        security_Admins: this.value.security_Admins || '',
        appControlMergeFile: this.value.appControlMergeFile || '',
        authentication: this.value.authentication || '',
        hybridConnection: this.value.hybridConnection || false,
        hybridConnectionHost: this.value.hybridConnectionHost,
        hybridConnectionPort: this.value.hybridConnectionPort,
        webVersionName: this.value.webVersionName || '',
      },
      locations: [
        { value: 'North Europe', text: 'North Europe' },
        { value: 'West Europe', text: 'West Europe' },
        { value: 'Australia East', text: 'Australia East' },
        { value: 'UK South', text: 'UK South' },
        { value: 'UK West', text: 'UK West' },
        { value: 'Southeast Asia', text: 'Southeast Asia' },
        { value: 'East US', text: 'East US' },
        { value: 'East US 2', text: 'East US 2' },
        { value: 'Central US', text: 'Central US' },
        { value: 'West US', text: 'West US' },
        { value: 'West US 2', text: 'West US 2' },
        { value: 'Canada Central', text: 'Canada Central' },
        { value: 'Japan East', text: 'Japan East' },
      ],
      partners: [
        { value: 'BC ONPREM', text: 'BC ONPREM'},
        { value: 'BC ONLINE', text: 'BC ONLINE'},
        { value: 'BC ONLINE vNext', text: 'BC ONLINE vNext'},
        { value: 'FO', text: 'FO'},
        { value: 'FO vNext', text: 'FO vNext'}
      ],
      partnerBC: [
        { value: 'BC ONPREM', text: 'BC ONPREM'},
        { value: 'BC ONLINE', text: 'BC ONLINE'},
        { value: 'BC ONLINE vNext', text: 'BC ONLINE vNext'},
      ],
      disabledBC: [
        { value: 'BC', text: 'BC'},
        { value: 'FO', text: 'FO'}
      ],
      authOptions:[
        { value: 'ticket', text: 'Ticket'},
        { value: 'aad', text: 'AAD'}
      ],
      formsTestSitePassword: this.value.formsTestSitePassword || '',
      exflowUrl: this.value.exflowUrl || '',
      outboundIpAddresses: this.value.outboundIpAddresses || '',
      adminConsent: this.value.adminConsent || '', 
      user: this.userValue,
      errors: '',
      userToken: this.token,
      localDisable: this.hdlDisable() || false,
      exceptionDisable: false,
      bcUrList: ['api.businesscentral.dynamics.com','wiise.api.bc.dynamics.com','lscentral.api.bc.dynamics.com'],
      showDelete: false,
      showMore: false,
      showMigrate: false,
      disableBtnDeployment: false,
      showActionRequired: false,
      toggleEnv: false,
      environmentValue: "npe",
      migrateInterval: 2000,
    }
  },
  mounted(){
      if(this.dynamics == 'FO'){
        this.customer.authentication = 'aad'
      }
      if(this.dynamics == 'BC'){
        this.localDisable = false
      }
  },
  watch:{
    value:{
      handler(value){
        this.customer.hybridConnection = value.hybridConnection
        this.customer.deployType = value.deployType
      },
      deep:true
    },
    dynamics(){
      this.customer.dynamics = this.dynamics
      if(this.dynamics == 'BC'){
        this.customer.authentication = ''
        this.localDisable = false
      }
      if(this.dynamics == ''){
         this.customer.dynamics = 'BC ONPREM'
         this.customer.authentication = ''
         this.localDisable = false
      }
      if(this.dynamics == 'FO'){
         this.customer.dynamics = 'FO'
         this.customer.authentication = 'aad'
         this.localDisable = true
      }
    },
  },
  computed:{
    deployTypeCheck(){
      return this.value.deployType == "npe" || "" ? false : true
    },
    migrationStatus(){
      if(this.value.BCOAuthMigration && this.value.url){
        let url = new URL(this.value.url)
        return this.value.BCOAuthMigration.toLowerCase() == 'complete' && this.bcUrList.includes(url.host) ? true : false
      }else{
        return false
      }
    },
    isMigrated(){
      if(this.value.BCOAuthMigration && this.value.url){
        let url = new URL(this.value.url)
      return  this.value.BCOAuthMigration.toLowerCase() == 'prepared' && this.bcUrList.includes(url.host) ? true : false
      }else{
        return false
      }
    },
    togglePartner(){
      return this.value.dynamics == "BC" && this.disable || this.dynamics == "BC" && !this.disable ?  this.partnerBC : this.partners
    },
    toggleField(){
      return this.customer.dynamics == 'BC ONPREM' || this.customer.dynamics == 'BC ONLINE' || this.customer.dynamics == 'BC ONLINE vNext' || this.customer.dynamics == 'BC' ? true : false
    },
    isBcOnPrem(){
        return this.customer.dynamics == 'BC ONPREM' ? true : false   
    },
    
    isvNext(){
      return this.customer.dynamics == 'BC ONLINE vNext' || this.customer.dynamics == 'FO vNext'? false : true
    },
    checkEdit(){
      return this.disable && this.value.dynamicsSerialNumber == null ? false : true
    }
  },
  methods: {
    hdlEnvCheckBox() {
      this.toggleEnv = !this.toggleEnv
      this.toggleEnv ? this.environmentValue = "prod" : this.environmentValue = "npe"
    },
    hdlEnvironment(){
      this.disableBtnDeployment = true
      this.$emit('getLoad', true, 'Sending deployment..')

      const data = {
        "resourceId": this.value.resourceId,
        "deployType": this.environmentValue
      }

      this.$http('api/register/environment', 'POST', this.token, data)
        .then(data => {
          setTimeout( ()=> { // delayed for list to refresh properly
            this.disableBtnDeployment = false
            this.$emit('getLoad', false, '')
            this.$toasted.global.success_message({message: `<p>Deployment successfully changed!</p>`})
            this.$router.push({ name: 'list' })
            return data
          }, 20000);
        })
        .catch(error => {
          this.disableBtnDeployment = false
          if (error.status === 401) {
            this.$emit('getLoad', false, '')
            this.$emit('getUser', '')
            this.$emit('getToken', '')
            sessionStorage.clear()
            this.$toasted.global.error_login(
              'You are not Authorized. Token might have expired. Please log in again'
            )
          } else if(error.status  === 400) {
            let obj = JSON.parse(error.error)
            let errors = Object.values(obj)
            let errormessage = document.createElement('ul')

            errormessage.innerHTML = errors
              .map(error => `<li>${error}</li>`)
              .join('')
            //Stop showing loading animation
            this.$emit('getLoad', false, '')
            //Show notification error
            this.$toasted.global.error_message({message:errormessage})
            return errors
          } else{
          //  else(error.status === 500 || error.status === 404) {
            this.$emit('getLoad', false, '')
            this.$toasted.global.error_message({message: error.statusText})
          }
        })
    },
    hdlActionRequired(){
      this.showActionRequired = true
    },
    hdlCancelActionRequired()      {
      this.showActionRequired = false
    },
    hdlMore(){
      this.showMore = !this.showMore
    },
    hdlMoreClose(){
      this.showMore = false
    },
    hdlRestart(){
      this.disableBtnDeployment = true
      this.$emit('getLoad', true, 'Restarting deployment..')
      this.$http('api/register/restart', 'POST', this.token, this.value)
        .then(data => {
            this.disableBtnDeployment = false
            this.$emit('getLoad', false, '')
            this.showMore = false
            this.$toasted.global.success_message({message: `<p>Deployment restarted!</p>`})
            return data
        })
        .catch(error => {
          this.disableBtnDeployment = false
          if (error.status === 401) {
            this.$emit('getLoad', false, '')
            this.$emit('getUser', '')
            this.$emit('getToken', '')
            sessionStorage.clear()
            this.$toasted.global.error_login(
              'You are not Authorized. Token might have expired. Please log in again'
            )
          } else if(error.status  === 400) {
            let obj = JSON.parse(error.error)
            let errors = Object.values(obj)
            let errormessage = document.createElement('ul')

            errormessage.innerHTML = errors
              .map(error => `<li>${error}</li>`)
              .join('')
            //Stop showing loading animation
            this.$emit('getLoad', false, '')
            //Show notification error
            this.$toasted.global.error_message({message:errormessage})
            return errors
          } else{
          //  else(error.status === 500 || error.status === 404) {
            this.$emit('getLoad', false, '')
            this.$toasted.global.error_message({message: error.statusText})
          }
        })
    },
    hdlPostpone(){
      this.disableBtnDeployment = true
      this.$emit('getLoad', true, 'Postponing deployment..')
      this.$http('api/register/postpone', 'POST', this.token, this.value)
        .then(data => {
          setTimeout( ()=> { // delayed for list to refresh properly
            this.disableBtnDeployment = false
            this.$emit('getLoad', false, '')
            this.$toasted.global.success_message({message: `<p>Deployment has been postponed!</p>`})
            this.$router.push({ name: 'list' })
            return data
          }, 30000);
        })
        .catch(error => {
          this.disableBtnDeployment = false
          if (error.status === 401) {
            this.$emit('getLoad', false, '')
            this.$emit('getUser', '')
            this.$emit('getToken', '')
            sessionStorage.clear()
            this.$toasted.global.error_login(
              'You are not Authorized. Token might have expired. Please log in again'
            )
          } else if(error.status  === 400) {
            let obj = JSON.parse(error.error)
            let errors = Object.values(obj)
            let errormessage = document.createElement('ul')

            errormessage.innerHTML = errors
              .map(error => `<li>${error}</li>`)
              .join('')
            //Stop showing loading animation
            this.$emit('getLoad', false, '')
            //Show notification error
            this.$toasted.global.error_message({message:errormessage})
            return errors
          } else{
          //  else(error.status === 500 || error.status === 404) {
            this.$emit('getLoad', false, '')
            this.$toasted.global.error_message({message: error.statusText})
          }
        })
    },
    hdlOpenDelete(){
      this.showDelete = true
    },
    hdlOpenMigrate(){
      this.showMigrate = true
    },
    async hdlDelete(){
      this.disableBtnDeployment = true
      this.$emit('getLoad', true, 'Deleting deployment..')
      await this.$http('api/register/delete', 'POST', this.token, this.value)
        .then(data => {
          data.location != null ? this.pollStatus("api/register/vnext-status", data.location, "Deletion") :  Promise.reject(new Error('Data location is null'));
          return data
        })
        .catch(error => {
          this.disableBtnDeployment = false
          if (error.status === 401) {
            this.$emit('getLoad', false, '')
            this.$emit('getUser', '')
            this.$emit('getToken', '')
            sessionStorage.clear()
            this.$toasted.global.error_login(
              'You are not Authorized. Token might have expired. Please log in again'
            )
          } else if(error.status  === 400) {
            let obj = JSON.parse(error.error)
            let errors = Object.values(obj)
            let errormessage = document.createElement('ul')

            errormessage.innerHTML = errors
              .map(error => `<li>${error}</li>`)
              .join('')
            //Stop showing loading animation
            this.$emit('getLoad', false, '')
            //Show notification error
            this.$toasted.global.error_message({message:errormessage})
            return errors
          } else{
          //  else(error.status === 500 || error.status === 404) {
            this.$emit('getLoad', false, '')
            this.$toasted.global.error_message({message: error.statusText})
          }
        })
    },
    hdlCancel(){
      this.showDelete = false
    },
    hdlCancelMigrate(){
      this.showMigrate = false
    },
    hdlProdEnvCheckBox(v){
      this.$emit('getDeployType', v)
    },
    hdlPaste(event){
         return event.clipboardData.getData('text/plain')
    },
    hdlExceptions(e){
      this.showMore = false
      this.exceptionDisable = true
      setTimeout( () => {this.exceptionDisable = false}, 5000)
      this.$emit('getLoad', true, 'Loading..')
      this.$emit('getExceptions', {"customerName": this.value.customerName})
    },
    disableDynamics(){
      if(this.disable){
        return true
      }
      else{
        switch(this.dynamics){
          case '':
            return false
          case 'BC':
            return false
          case 'FO':
            return true
        }
      }
    },
    hdlDisable(){
      if(this.disable && this.value.dynamics == 'BC ONPREM'){
        return false
        }
      if(this.disable && this.value.dynamics == 'FO'){
        return true
      }else{
        switch(this.dynamics){
          case '':
            return false
          case 'BC ONPREM':
            return true
          case 'BC ONLINE':
            return true
          case 'FO':
            return true
        }
      }
    },
    hdlDynamics(event){
      this.$refs.auth.isActive = true //hackish way to activate label input
      if(event.target.value == "FO") {
        this.customer.authentication = 'aad'
        this.customer.appControlMergeFile = 'App.AX.WS.xml?{ax365api1}=true;{UseDebugLog}=false;{Lines.RemoveOrginal}=true;{Lines.ChangeType}=true;{ForwardTo}=true;{ForwardTo.NoPrevious}=true;{Lang.All}=true;{Lines.UseLineTemplates}=true;{Lines.UseAsyncValidation}=true;{Labs.Vue.InAppSiteConfiguration}=true;'
        this.localDisable = true 
        this.$emit('gethybrid', false)
      }else if(event.target.value == "FO vNext") {
        this.customer.authentication = 'aad'
        this.customer.appControlMergeFile = ''
        this.customer.deployType = 'npe'
        this.localDisable = true 
        this.$emit('gethybrid', false)
      }else if(event.target.value == "BC ONLINE") {
        this.customer.authentication = 'aad'
        this.customer.appControlMergeFile = 'App.NAV.WS.xml?{DebugLog}=false;{FormsTestSite}=false;{PurchaseDisabled}=true;{UseNAVSSOEmailing}=true'
        this.localDisable = true
        this.$emit('gethybrid', false)
      }else if(event.target.value == "BC ONLINE vNext") {
        this.customer.authentication = 'aad'
        this.customer.appControlMergeFile = ''
        this.customer.deployType = 'npe'
        this.localDisable = true
        this.$emit('gethybrid', false)
      }
       else{
          this.customer.authentication = ''
          this.customer.appControlMergeFile = 'App.NAV.WS.xml?{DebugLog}=false;{FormsTestSite}=false;{PurchaseDisabled}=true;{UseNAVSSOEmailing}=true'
          this.localDisable = false
          this.$emit('gethybrid', false)
        }
    },
    checkPartner(){
        // if(this.dynamics == '') return 'BC'
        if(this.value.dynamics){
            if(this.value.dynamics == 'FO' && this.value.webVersionName == "vNext"){
              setTimeout( ()=> {this.localDisable = true}, 100);
              return 'FO vNext'
            }else if(this.value.dynamics == 'BC'&& this.value.webVersionName == "vNext"){
              setTimeout( ()=> {this.localDisable = true}, 100);
              return 'BC ONLINE vNext'
            }else if(this.value.dynamics == 'BC' && this.value.url != ''){
              let bcUrls = ['api.businesscentral.dynamics.com','wiise.api.bc.dynamics.com','lscentral.api.bc.dynamics.com']
              let url = new URL(this.value.url)
              if(bcUrls.includes(url.host) ){
                setTimeout( ()=> {
                  this.customer.authentication = "aad"
                  this.localDisable = true 
                  }, 100);
                return "BC ONLINE"
              }else {
                return "BC ONPREM"
              }
            }
          // return this.value.dynamics
        }else{
          switch(this.dynamics){
          case 'FO': 
              return 'FO'
          case 'BC':
              return 'BC ONPREM'
          default: return 'BC ONPREM'
          }
        }
    },
    register() {
      // Show loading animation
      this.$emit('getLoad', true, 'This may take a while..')
      this.$http('api/register', 'POST', this.token, this.customer)
        .then(data => {
          // let json = JSON.parse(data)
          // let jobId = json.JobIds[0].replace(/[\]']+/g, '').toString()
          this.$emit('getDeploymentInfo', data)
          return data
        })
        .catch(error => {
          if (error.status === 401) {
            this.$emit('getLoad', false, '')
            this.$emit('getUser', '')
            this.$emit('getToken', '')
            sessionStorage.clear()
            this.$toasted.global.error_login(
              'You are not Authorized. Token might have expired. Please log in again'
            )
          } else if(error.status  === 400) {
            let obj = JSON.parse(error.error)
            let errors = Object.values(obj)
            let errormessage = document.createElement('ul')

            errormessage.innerHTML = errors
              .map(error => `<li>${error}</li>`)
              .join('')
            //Stop showing loading animation
            this.$emit('getLoad', false, '')
            //Show notification error
            this.$toasted.global.error_message({message:errormessage})
            return errors
          } else{
          //  else(error.status === 500 || error.status === 404) {
            this.$emit('getLoad', false, '')
            this.$toasted.global.error_message({message: error.statusText})
          }
        })
    },
    migrate(){
      this.$set(this.customer, 'resourceId', this.value.resourceId)  //info about set https://v2.vuejs.org/v2/guide/reactivity.html
      this.$emit('getLoad', true, 'This may take a while..')
      this.$http('api/register/migrate', 'POST', this.token, this.customer)
        .then(data => {
           this.$emit('getLoad', false, '')
           this.$toasted.global.success_message(`Migration status: ${data.status}`)
           this.$router.push({ name: 'list' })
          return data
        })
        .catch(error => {
          if (error.status === 401) {
            this.$emit('getLoad', false, '')
            this.$emit('getUser', '')
            this.$emit('getToken', '')
            sessionStorage.clear()
            this.$toasted.global.error_login(
              'You are not Authorized. Token might have expired. Please log in again'
            )
          } else if(error.status  === 400) {
            let obj = JSON.parse(error.error)
            let errors = Object.values(obj)
            let errormessage = document.createElement('ul')

            errormessage.innerHTML = errors
              .map(error => `<li>${error}</li>`)
              .join('')
            //Stop showing loading animation
            this.$emit('getLoad', false, '')
            //Show notification error
            this.$toasted.global.error_message({message:errormessage})
            return errors
          } else{
          //  else(error.status === 500 || error.status === 404) {
            this.$emit('getLoad', false, '')
            this.$toasted.global.error_message({message: error.statusText})
          }
        })
    },
    async migratevNext() {
      //vnextMigration : null / Prepared / ActionRequired / Postponed / Complete
      this.disableBtnDeployment = true
      // Show loading animation
      this.$emit('getLoad', true, 'This may take a while..')
      await this.$http('api/register/migrate-vnext', 'POST', this.token, this.value)
        .then(data => {
          data.location != null ? this.pollStatus("api/register/vnext-status", data.location , "Migration") :  Promise.reject(new Error('Data location is null'));
        })
        .catch(error => {
          this.disableBtnDeployment = false
          //Stop showing loading animation
          this.$emit('getLoad', false, '')
          if (error.status === 401) {
            this.$emit('getUser', '')
            this.$emit('getToken', '')
            sessionStorage.clear()
            this.$toasted.global.error_login(
              'You are not Authorized. Token might have expired. Please log in again'
            )
          } else if(error.status  === 400) {
            let obj = JSON.parse(error.error)
            let errors = Object.values(obj)
            let errormessage = document.createElement('ul')

            errormessage.innerHTML = errors
              .map(error => `<li>${error}</li>`)
              .join('')

            //Show notification error
            this.$toasted.global.error_message({message:errormessage})
            return errors
          } else{
          //  else(error.status === 500 || error.status === 404) {
            this.$toasted.global.error_message({message: error.statusText})
          }
        })
    },
    async pollStatus(url, locationUrl, successMessage) {
      let networkPromise = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + this.token,
          'Content-Type': 'application/json' // Add Content-Type header
        },
        body: JSON.stringify({ location: locationUrl })
      }).then(resp => {
        return resp.status >= 400 ? Promise.reject(resp) : Promise.resolve(resp)
      })
        .then((response) => response.json())
        .catch(e => {
          this.$emit('getLoad', false, '')
          this.$toasted.global.error_message({ message: e.statusText })
        })
      //This promise will resolve depending on refreshInterval value(seconds) have passed
      let timeOutPromise = new Promise( (resolve, reject)=> {
        //Delay the call
        setTimeout(resolve, this.migrateInterval); // third argument used for commenting
      });
      Promise.all([networkPromise, timeOutPromise])
        .then((data) => {
          if (data[0].properties.status == "Successful") {
            this.$emit('getLoad', false, '')
            this.showMore = false
            this.showMigrate = false
            this.disableBtnDeployment = false
            this.$toasted.global.success_message({message: `<p>${successMessage} Successful!</p>`})
            this.$router.push({ name: 'list' })
          }else if(data[0].properties.status == "Failed") {
            this.$emit('getLoad', false, '')
            this.$toasted.global.error_message({message: `<p>${successMessage} Failed</p>`})
          }
          else{
             this.pollStatus(url, locationUrl, successMessage)
          }
        })
        .catch((error) => {
          this.disableBtnDeployment = false
          console.log('fetch failed', error);
          this.$emit('getLoad', false, '')
          this.$toasted.global.error_message({message: "Something went wrong"})
        });
    },
    hdlCheckBox(v) {
      this.$emit('gethybrid', v)
    },
    hdlClipBoard(t) {
      navigator.clipboard.writeText(t)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style :scoped>
.migrate{
  margin: 0 auto;
}
.migrate svg, .postpone svg{
  padding-left: 5px;
  float: right;
  color: var(--o-success);
  font-size: 16px;
}
.register-wrap {
  display: flex;
  flex-direction: column;
}
#formlog {
  display: flex;
  width: 100%;
  max-width: 310px;
  margin: 0 auto;
  flex-direction: column;
  padding: 15px;
  background-color: var(--o-text-on-bg);
}
#formlog input[type="text"]:disabled{
  color: var(--o-text-disabled);
  background-color: var(--o-bg1);
}
textarea {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  height: 20px;
}
.textInfo {
  font-size: 15px;
  float: right;
}
.texterror {
  font-size: 15px;
  color: var(--o-error);
  float: right;
}
.btn-wrapper{
  display: flex;
  justify-content: space-between;
}
.close-btn-more .oBtn{
  padding: 2px 4px 0 4px;
  background-color: var(--o-text-on-bg);
  color: var(--o-primary);
  font-size: 30px;
  right: 4px;
  position: absolute;
  top: 4px;
  background: transparent;
}
.btnDelete{
  --o-primary: #f44336;
  --o-text-on-bg:#ffffff;
}
.btnDelete .outline{
  --o-primary: #ffffff;
  --o-text-on-bg: #f44336;
  --o-border:  1px solid #f44336;
}
.btnSubmit{
  margin-left: auto;
  margin-top: 5px;
}
.more-btn-wrapper{
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 400px;
  height: 250px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  position: relative;
  background-color: var(--o-bg1);
  margin: 0 auto;
}
.delete-window, .migrate-window, .more-window-wrap,.action-window {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: #0000002e;
  z-index: 100;
}
.delete-window-wrap, .migrate-window-wrap , .action-window-wrap{
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 400px;
  height: 250px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  position: relative;
  background-color: var(--o-bg1);
  margin: 0 auto;
}
.migrate-btn-wrapper, .action-btn-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;;
}
.migrate-postpone-btn-wrapper {
  display: flex;
  flex-direction: column;
}
.del-btn-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.btn-clipboard {
  position: absolute;
  right: -40px;
  top: -10px;
}
.btn-clipboard button{
  background-color: var(--o-bg1) !important;
  color: var(--o-primary) !important;
  padding: 8.5px 12px !important;
  cursor: pointer !important;
}
.btn-clipboard button:active{
  border: 1px solid var(--o-text-on-bg) !important;
}
.fa-clipboard{
  font-size: 20px;
}
/*Css variables Overrides */
.o-outline-light{
  margin-top: 5px;
  --o-primary: #ffffff;
  --o-text-on-bg: #5d6e7b;
  --o-border:  1px solid #d6d6d6;
}
.o-outline-light-action{
  margin-top: 5px;
  --o-primary: #ffffff;
  --o-text-on-bg: #FF6F00;
  --o-border:  1px solid #FF6F00;
}
.o-outline-light .btn-disabled{
 --o-disable: #ffffff;
 --o-bg1: #d6d6d6;
}
/* ================================= 
  Media Queries
==================================== */

@media (min-width: 769px) {
  #formlog {
    max-width: 402px;
    padding: 20px 88px;
  }
}
@media (min-width: 1025px) {
  #formlog {
    max-width: 402px;
    padding: 20px 88px;
  }
}
</style>
